import gql from 'graphql-tag'

export const UNDO_LEAVE_IMPORT = gql`
  mutation UndoLeaveImport($input: UndoLeaveImportInput!) {
    undoLeaveImport(input: $input)
  }
`
